const cumulativeOffset = (element) => {
  let top = 0;
  let left = 0;
  do {
    top += element.offsetTop || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent; /* eslint-disable-line no-param-reassign */
  } while (element);

  return {
    top,
    left,
  };
};

const isElementContained = (element, ancestorSelector) => {
  const ancestor = document.querySelector(ancestorSelector);
  if (!ancestor) {
    return false;
  }
  return ancestor.contains(element);
};

const getElementLink = (element) => {
  const isLink = element.nodeName === 'A';
  if (isLink) {
    return element;
  }
  const wrapper = element.closest('a');
  return wrapper;
};

const getScriptData = (attributeName) => {
  const script = document.currentScript || [...document.getElementsByTagName('script')].pop();
  return script.dataset[attributeName] || null;
};

export {
  cumulativeOffset,
  getElementLink,
  getScriptData,
  isElementContained,
};
